export class CompanyValidationPatterns {
	static Phone = /^\+?[1-9][\d\s-]*$/;
	static Email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
}